import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './StationName.css';
export function StationName(_ref) {
  var active = _ref.active,
      onClick = _ref.onClick,
      text = _ref.text,
      rect = _ref.rect;
  var styleObject = React.useMemo(function () {
    return _objectSpread(_objectSpread({
      fontSize: "".concat(text.size, "px")
    }, !active ? {
      color: "".concat(text.color)
    } : {}), {}, {
      left: "".concat(rect.x, "px"),
      top: "".concat(rect.y, "px")
    });
  }, [active, rect.x, rect.y, text.color, text.size]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "station-name",
    onClick: onClick,
    className: clsx(styles['name'], active && styles['name_active']),
    style: styleObject
  }, text.value);
}